export class  QueryRequestModel
{
QueryCode : number
QueryRequestNumber :string;
QueryDetailCode : number;
CreatedByUserCode: number;
CreatedByUserName :string;
RequestorCode: number;
RequestorName:string;
RequestedDate : Date;
RequestedDateInString:string;
//CompanyCode: number;
CompanyName: string;
//BlockCode: number;
Block :string;
//DepartmentCode: number;
Department :string;
//SubDeptCode: number;
SubDeptartment :string;
QueryStatusCode: number;
PartnerQueryStatusCode: number;
QueryStatus :string;
PartnerQueryStatus :string;
//CategoryCode : number;
Category :string;
//SubCategoryCode : number;
SubCategory :string;
ContractNumber :string;
AFENUmber :string;
WorkOrderNumber :string;
SIOPNumber :string;
LetterReferenceNumber:string;
PartnerComment:string;
ResolutionComment:string;
QueryReqDueDate : Date;
QueryReqDueDateInString :string;
QueryDetailsStatus : boolean;

QueryAnsBy: string;
RespondedDate : Date;
RespondedDateInString:string;
QueryAssignedTo:string;
PriorityLevel: string;
IsConfidential: boolean;
Confidential : string;

DeleteComment : string;
QueryComments : string;
QueryAttachments : string;
QueryCCUsers : string;
QueryCCDepts : string;
Subject:string;
constructor() {
    this.QueryCode = 0;
    this.QueryRequestNumber = '';
    this.QueryDetailCode = 0;
    this.CreatedByUserCode = 0;
    this.CreatedByUserName = '';
    this.RequestorCode = 0;
    this.RequestorName = '';
    this.RequestedDate = new Date();
    this.RequestedDateInString = '';
    this.CompanyName = '';
    this.Block = '';
    this.Department = '';
    this.SubDeptartment = '';
    this.QueryStatusCode = 0;
    this.PartnerQueryStatusCode = 0;
    this.QueryStatus = '';
    this.PartnerQueryStatus = '';
    this.Category = '';
    this.SubCategory = '';
    this.ContractNumber = '';
    this.AFENUmber = '';
    this.WorkOrderNumber = '';
    this.SIOPNumber = '';
    this.LetterReferenceNumber = '';
    this.PartnerComment = '';
    this.ResolutionComment = '';
    this.QueryReqDueDate = new Date();
    this.QueryReqDueDateInString = '';
    this.QueryDetailsStatus = false;
    this.QueryAnsBy = '';
    this.RespondedDate = new Date();
    this.RespondedDateInString = '';
    this.QueryAssignedTo = '';
    this.PriorityLevel = '';
    this.IsConfidential = false;
    this.Confidential = '';
    this.DeleteComment = '';
    this.QueryComments = '';
    this.QueryAttachments = '';
    this.QueryCCUsers = '';
    this.QueryCCDepts = '';
    this.Subject = '';
}
}
